import React from 'react';
import { Dialog, DialogTitle, Button } from 'material-ui';
import { Link } from 'react-router-dom';
import { CSVLink } from 'react-csv';

import IconButton from 'material-ui/IconButton';
import Close from 'material-ui-icons/Cancel';
import Download from 'material-ui-icons/FileDownload';

import Table from '../../helpers/Table';

import vxclogo from '../../images/VXC.png';

import buildVXCPortfolioAuditCsvData from '../../helpers/reports/csv/buildVXCPortfolioAuditCsvData';

const moment = require('moment');

const centerDiv = {
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '-9px'
};

const PostFrame = (props) => {
  const columns = [
    { name: 'portfolio', title: 'Portfolio' },
    { name: 'action', title: 'Event' },
    { name: 'timestamp', title: 'Time' },
  ];
  const report = props.report ? props.report : [];
  report.forEach((el, index) => {
    el.timestamp = moment(el.timestamp).format('MM/DD/YYYY h:mm:ss A');
    el.portfolio = index === 0 ? props.selectedPortfolio : '';
  });
  const date = new Date();
  const fileName = `PortfolioAuditReport_for_${props.selectedCustomer}_${props.selectedPortfolio}_run_on_${date.toLocaleDateString().replace(/\//g, '_')}.csv`;
  return (
    <Dialog open={props.displayDialog} fullScreen>
      <DialogTitle style={{ height: '20px' }}>
        <IconButton style={{ float: 'right', marginTop: '-10px' }} title="close" component="span" onClick={o => props.hideModal()}>
          <Close color="disabled" />
        </IconButton>
      </DialogTitle>
      <div>
        <u><span style={{ marginLeft: 'calc(100% - 50%)' }}>{props.selectedCustomer}</span></u>
        <CSVLink
          data={buildVXCPortfolioAuditCsvData(report)}
          filename={fileName}
          style={{ color: 'white', float : 'right', marginRight: '5%' }}
        >
          <IconButton title="Click here to download" component="span" onClick={this.handleReportClick}>
            <Download color="disabled" />
          </IconButton>
        </CSVLink>
      </div>
      <div id="striped_table" align="center" style={{ marginBottom:'2%' }}>
        <Table columns={columns} rows={report} />
      </div>
    </Dialog>
  );
};

export default PostFrame;


// WEBPACK FOOTER //
// ./src/components/VXC/PostFrame.js